export default {
  default: () => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m),
  login: () => import("/opt/build/repo/layouts/login.vue").then(m => m.default || m)
}